import { HereLayer } from 'common/utils/MapMarker/types';
import { useMemo } from 'react';
import { getHistoryEventIcon } from '../utills';
import { getCarIcon } from 'features/cars/CarEBoxLocations/utils';
import { useClientEventsHistoryFilter, useNavigationHistoryPath } from 'entities/navigation';
import { EMPTY_ARRAY } from 'common/constants';

export const useStopTruckHistoryEventsMarkerLayer = () => {
  const navigationHistoryPath = useNavigationHistoryPath();
  const clientEventFilter = useClientEventsHistoryFilter();

  const data = useMemo(
    () =>
      (navigationHistoryPath || EMPTY_ARRAY)
        .map(({ locations, type }) => {
          if (type !== 'Parking' || (clientEventFilter.length > 0 && !clientEventFilter.includes(type))) {
            return null;
          }

          const [{ latitude, longitude }] = locations;
          return {
            longitude,
            latitude,
            type,
          };
        })
        .filter((x) => x !== null),
    [clientEventFilter, navigationHistoryPath]
  );

  const clientHistoryEventsMarkersLayer = useMemo(
    (): HereLayer => ({
      data,
      name: 'path-parking-history-events',
      type: 'marker',
      getCoordinates: ({ data: { longitude, latitude } }) => ({
        latitude,
        longitude,
      }),
      getIcon: ({ clusterWeight }) => {
        if (clusterWeight) {
          const { url, width, height } = getCarIcon({
            properties: {
              cluster: true,
              point_count: clusterWeight,
            },
          });

          return {
            url,
            width,
            height,
            anchorY: height,
            anchorX: width / 2,
          };
        }

        const { url, height, width } = getHistoryEventIcon('Parking')!;
        return {
          url,
          height,
          width,
          anchorY: height,
          anchorX: width / 2,
        };
      },
    }),
    [data]
  );

  return clientHistoryEventsMarkersLayer;
};

export const useUntrackHistoryEventsMarkerLayer = () => {
  const navigationHistoryPath = useNavigationHistoryPath();
  const clientEventFilter = useClientEventsHistoryFilter();

  const data = useMemo(
    () =>
      (navigationHistoryPath || [])
        .map(({ locations, type }) => {
          if (type !== 'Untracked' || (clientEventFilter.length > 0 && !clientEventFilter.includes(type))) {
            return null;
          }

          const [{ latitude, longitude }] = locations;
          return {
            longitude,
            latitude,
            type,
          };
        })
        .filter((x) => x !== null),
    [clientEventFilter, navigationHistoryPath]
  );

  const clientHistoryEventsMarkersLayer = useMemo(
    (): HereLayer => ({
      data,
      name: 'path-untrack-history-events',
      type: 'marker',
      getCoordinates: ({ data: { longitude, latitude } }) => ({
        latitude,
        longitude,
      }),
      getIcon: ({ clusterWeight }) => {
        if (clusterWeight) {
          const { url, width, height } = getCarIcon({
            properties: {
              cluster: true,
              point_count: clusterWeight,
            },
          });

          return {
            url,
            width,
            height,
            anchorY: height,
            anchorX: width / 2,
          };
        }

        const { url, height, width } = getHistoryEventIcon('Untracked')!;

        return {
          url,
          height,
          width,
          anchorY: height,
          anchorX: width,
        };
      },
    }),
    [data]
  );

  return clientHistoryEventsMarkersLayer;
};
